import React from "react";
import { Route, Routes } from "react-router-dom";
import MainTeamPage from "./MainTeamPage";
import ProtectedRoute from "../../ProtectedRoute";
import AddEditTeamPage from "./AddEditTeamPage";
import TeamPageWrapper from "./TeamPageWrapper";
import ViewTeamPage from "./ViewTeamPage";
import PageNotFound from "../PageNotFound";

const TeamRouter: React.FC = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute
            element={<TeamPageWrapper Component={MainTeamPage} />}
          />
        }
      />
      <Route
        path="create"
        element={
          <ProtectedRoute
            element={<TeamPageWrapper Component={AddEditTeamPage} />}
          />
        }
      />

      <Route
        path=":_id/edit"
        element={
          <ProtectedRoute
            element={<TeamPageWrapper Component={AddEditTeamPage} />}
          />
        }
      />
      <Route
        path=":_id"
        element={
          <ProtectedRoute
            element={<TeamPageWrapper Component={ViewTeamPage} />}
          />
        }
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default TeamRouter;
